import React, { useState, useEffect } from "react";
import { Campaign } from "../../data/campaignData";
import { apiService } from "../../services/api";
import { CampaignAdapter } from "../../services/campaignAdapter";
import CampaignConversionMenu from "./CampaignConversionMenu";
import CampaignConversionLayout from "./CampaignConversionLayout";
import LineChart from "./charts/LineChart";
import PieChart from "./charts/PieChart";
import BarChart from "./charts/BarChart";
import StatisticsCards from "./charts/StatisticsCards";

const CampaignConversionPage: React.FC = () => {
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);
  const [selectedCampaignId, setSelectedCampaignId] = useState<string | null>(
    null
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Load campaigns from API
  useEffect(() => {
    const loadCampaigns = async () => {
      try {
        setLoading(true);
        console.log("Loading campaigns...");
        const response = await apiService.getCampaigns();
        console.log("API response:", response);
        const legacyCampaigns = CampaignAdapter.toLegacyArray(response.data);
        console.log("Legacy campaigns:", legacyCampaigns);
        setCampaigns(legacyCampaigns);
      } catch (err) {
        console.error("Error loading campaigns:", err);
        setError("Không thể tải danh sách chiến dịch");
      } finally {
        setLoading(false);
      }
    };

    loadCampaigns();
  }, []);

  // Filter campaigns based on selection
  const filteredCampaigns = selectedCampaignId
    ? campaigns.filter((c) => c.id === selectedCampaignId)
    : campaigns;

  console.log("Filtered campaigns:", filteredCampaigns);
  console.log("Selected campaign ID:", selectedCampaignId);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Đang tải dữ liệu...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="text-red-600 text-lg font-medium">{error}</div>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Thử lại
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="h-[calc(100vh-8rem)] flex flex-col bg-gray-50 overflow-hidden -m-6">
      {/* Header with menu */}
      <CampaignConversionMenu
        campaigns={campaigns}
        selectedCampaignId={selectedCampaignId}
        onCampaignSelect={setSelectedCampaignId}
        pageTitle="Chuyển đổi Chiến dịch"
      />

      {/* Two page layout */}
      <CampaignConversionLayout
        leftPageTitle="Thống kê Chiến dịch"
        rightPageTitle="Phân tích Chiến dịch"
        leftPageContent={
          <div className="space-y-6">
            {/* Statistics Cards */}
            <StatisticsCards campaigns={filteredCampaigns} />

            {/* Bar Chart */}
            <div className="bg-white p-6 rounded-xl border border-gray-200">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Hiệu suất chiến dịch
              </h3>
              <BarChart filteredCampaigns={filteredCampaigns} />
            </div>
          </div>
        }
        rightPageContent={
          <div className="space-y-6">
            {/* Pie Chart */}
            <PieChart campaigns={filteredCampaigns} />

            {/* Line Chart */}
            <LineChart filteredCampaigns={filteredCampaigns} />
          </div>
        }
      />
    </div>
  );
};

export default CampaignConversionPage;
